// TODO: Remove this module from `core-js@4` since it's replaced to module below
require('../modules/es.weak-map.constructor');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.weak-map.js
// module id = 437
// module chunks = 0